export default __webpack_public_path__ + "assets/howToImport1.81008e42.gif";